import { ProcessTypes, UserProfile, UserWorkoutSession } from 'fitbeat.gym-core';
import { IDay } from 'fitbeat.models';
import React, { FunctionComponent } from 'react';
import { translate } from 'react-i18next';
import { ScrollView, StyleSheet, View } from 'react-native';
import { connect } from 'react-redux';
import { Button, ButtonSize, ButtonTypes } from '../../components';
import { IAppStore } from '../../HomeWorkouts';
import { getDatesForNextTwoWeeks } from '../../Planner/plannerActions';
import Theme from '../../theme';
import { FormError } from '../../ui';
import { i18n } from '../../utils';
import { defaultScale } from '../../utils/scaling';
import {
  getNextBookingStep,
  getPreviousBookingStep,
  workoutDateTimeSelected,
} from '../actions';
import {
  BookingFlowFooter, BookingInstructionHeader,
  DateTilesList
} from '../components';
import { styles as sharedStyles } from './Styles';

export interface IProps {
  day: IDay;
  userProfile: UserProfile;
  workoutSession: UserWorkoutSession;
  getNextBookingStep: any;
  getPreviousBookingStep: any;
  currentSelectedGymName: string;
  bookingSlotsError: string | null;
  pendingSlot: any;
  bookingProcess: ProcessTypes;
  t(key: string): string;
  workoutDateTimeSelected(date: Date): void;
}

const SelectStartDate: FunctionComponent<IProps> = ({
  t,
  day,
  userProfile,
  workoutSession,
  getNextBookingStep,
  getPreviousBookingStep,
  bookingSlotsError,
  pendingSlot,
  workoutDateTimeSelected,
  bookingProcess,
}) => {

  const nextClicked = () => {
    getNextBookingStep(userProfile);
  };

  const isDemoStudioBooking = bookingProcess === ProcessTypes.DemoStudioBooking;
  const dateList = getDatesForNextTwoWeeks();
  const BookingInstructionHeading = !isDemoStudioBooking  ? t('chooseStartDate') :
    t('bookingDaySelectHeaderForDemo');
  return (
    <View style={styles.container}>
      <View style={[sharedStyles.body, { top: 0 }]}>
        <BookingInstructionHeader header={ BookingInstructionHeading } />
          <DateTilesList
            selectedDate={day}
            dateList={dateList}
            workoutDateTimeSelected={workoutDateTimeSelected}
          />
      </View>
      <BookingFlowFooter>
        {bookingSlotsError && (
          <FormError error={new Error(bookingSlotsError)} />
        )}
        <View style={styles.footer}>
          {!isDemoStudioBooking && (
            <Button
              fontColor={Theme.PRIMARY}
              size={ButtonSize.MEDIUM}
              buttonType={ButtonTypes.OUTLINE}
              title={i18n.t('bookings:back')}
              onPress={() => getPreviousBookingStep()}
              containerStyle={styles.backContainer}
            />
          )}
          <Button
            size={ButtonSize.MEDIUM}
            fontColor={Theme.WHITE}
            title={i18n.t('bookings:next')}
            onPress={nextClicked}
            containerStyle={[
              styles.nextContainer,
              isDemoStudioBooking && { flex: 1 },
            ]}
          />
        </View>
      </BookingFlowFooter>
    </View>
  );
};

const mapStateToProps = (state: IAppStore): Partial<IProps> => {
  return {
    pendingSlot: state.bookings.bookingWizard.pendingSlot,
    workoutSession: state.bookings.bookingWizard.workoutSession,
    bookingProcess: state.bookings.bookingWizard.processType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getNextBookingStep: (userProfile, processType) =>
      dispatch(getNextBookingStep(userProfile, processType, undefined)),
    getPreviousBookingStep: () => dispatch(getPreviousBookingStep()),
    workoutDateTimeSelected: (date) => dispatch(workoutDateTimeSelected(date)),
  };
};

export const SelectStartDateStep = connect(mapStateToProps, mapDispatchToProps)(
  translate(['bookings', 'common'], { wait: true })(SelectStartDate));

SelectStartDateStep.getTitle = () => <></>;

const styles = StyleSheet.create({
  scrollViewContainer: {
    paddingBottom: defaultScale(60)
  },
  container: {
    flex: 1,
    justifyContent: 'flex-end',
  },
  loadingContainer: {
    flex: 1,
    alignItems: 'center',
  },
  dateTilesContainer : {
    alignItems: 'center',
  },
  studioHeader: {
    paddingTop: defaultScale(15),
    paddingBottom: 0,
  },
  footer: {
    flexDirection: 'row',
  },
  backContainer: {
    flex: 0.3,
  },
  nextContainer: {
    flex: 0.7,
    marginLeft: defaultScale(5),
  },
});
